import { useParams } from 'react-router-dom';
import useViewRealPlayQuery from 'features/realplays/services/queries/useViewRealplay';
import useGetAssignmentScenarioRatingQuery from 'features/realplays/services/queries/useGetAssignmentScenarioRating';
import useGetAssignmentScenarioResponseRatingQuery from 'features/realplays/services/queries/useGetAssigmentScenariosResponseRating';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import { useShouldShowNewIAReport, useShouldShowNewRolePlayChanges } from 'features/realplays/RealPlaysHook';

const ReviewQualifiedRealplayLogic = () => {
  const { uuid } = useParams();
  const { isLoading } = useViewRealPlayQuery({ uuid });
  const { assignment_uuid, selectedScenario } = RealPlayRecordDataHelper();
  const { enabled: showNewReport, isLoading: isLoadingFlag } = useShouldShowNewIAReport();
  const { active: showNewChanges } = useShouldShowNewRolePlayChanges();

  //TODO: used for retaken options
  // const { isLoading: loadingScenarioInfo } = useGetAssignmentScenarioRatingQuery({
  //   assignment_uuid,
  //   scenario_uuid: selectedScenario?.uuid,
  //   enabled: !!assignment_uuid && !!selectedScenario?.uuid,
  // });

  const { isLoading: loadingScenarioResponseInfo } = useGetAssignmentScenarioResponseRatingQuery({
    assignment_uuid,
    scenario_uuid: selectedScenario?.uuid,
    response_uuid: selectedScenario?.response?.uuid,
    enabled: !!assignment_uuid && !!selectedScenario?.uuid && !!selectedScenario?.response?.uuid,
  });

  return { isLoading, loadingScenarioResponseInfo, showNewReport, isLoadingFlag, showNewChanges };
};

export default ReviewQualifiedRealplayLogic;
